
import { STORE_REGISTER_FORM_DATA, STORE_REGISTER_FORM_DATA_FAILURE, STORE_REGISTER_FORM_DATA_SUCCESS, STORE_REGISTER_FORM_SUBMIT, STORE_REGISTER_FORM_SUBMIT_API_ERROR, STORE_REGISTER_FORM_SUBMIT_SUCCESS, STORE_REGISTER_FORM_SUBMIT_SUCCESS_POPUP } from './ActionTypes';


  //get store detail

  export const getStoreRegisterData = (values) => {
    return {
      type: STORE_REGISTER_FORM_DATA,
      payload: { values },
    };
  };

  export const getStoreRegisterDataSuccess = emailId => {
    return {
      type: STORE_REGISTER_FORM_DATA_SUCCESS,
      payload: emailId,
    };
  };

  export const getStoreRegisterDataFailure = emailId => {
    return {
      type: STORE_REGISTER_FORM_DATA_FAILURE,
      payload: emailId,
    };
  };


  //register form
  
  export const storeRegisterForm = (user, history) => {
    return {
      type: STORE_REGISTER_FORM_SUBMIT,
      payload: { user, history },
    };
  };
  
  export const storeRegisterFormSuccess = user => {
    return {
      type: STORE_REGISTER_FORM_SUBMIT_SUCCESS,
      payload: user,
    };
  };

  export const storeRegisterFormSuccessPopup = user => {
    return {
      type: STORE_REGISTER_FORM_SUBMIT_SUCCESS_POPUP,
      payload: user,
    };
  };
  
  export const storeRegisterFormError = error => {
    return {
      type: STORE_REGISTER_FORM_SUBMIT_API_ERROR,
      payload: error,
    };
  };